import React, { useMemo, useState } from 'react'
import CommonList from '../SettingsViews/CommonList'
import Portal from 'components/Portal/Portal'
import { Modal } from 'components/Modal/Modal'
import { ContextButton } from '@tecuity/granite-ui/ContextButton'
import { TextInput } from '@tecuity/granite-ui/TextInput'
import CrossHeavy from '@tecuity/sos-icons/react/cross-heavy'
import CaretDown from '@tecuity/sos-icons/react/caret-down'
import CaretUp from '@tecuity/sos-icons/react/caret-up'
import './ImageClassificationDefinitions.scss'

const ImageClassificationDefinitions = (props) => {
  const { property, ImagePageTypeId, onChange, optionsMap } = props
  const [classificationModalOpen, setClassificationModalOpen] = useState(false)
  const [showCategoryOptions, setShowCategoryOptions] = useState(false)
  const [showGroupOptions, setShowGroupOptions] = useState(false)
  const [category, setCategory] = useState('')
  const [group, setGroup] = useState('')
  const [showError, setShowError] = useState(false)

  const filteredList = useMemo(() => {
    if (!property.v) return []
    return property.v
      .filter((item) => !item.Delete)
      .map((item) => {
        return {
          Id: item.ImageClassificationDefinitionId || item.tempId,
          Name: `${item.ClassificationCategory} - ${item.Group}`,
        }
      })
  }, [property.v])

  const deleteClassification = (row) => {
    if (typeof row.Id === 'number') {
      onChange([
        ...property.v.map((item) => ({
          ...item,
          Delete: item.ImageClassificationDefinitionId === row.Id ? true : false,
        })),
      ])
    } else {
      onChange(property.v.filter((item) => !item.tempId || item.tempId !== row.Id))
    }
  }

  const closeModal = () => {
    setClassificationModalOpen(false)
    setCategory('')
    setGroup('')
  }

  const addClassification = () => {
    if (!category.trim() || !group.trim()) {
      setShowError(true)
      return
    }
    onChange([
      ...(property.v || []),
      {
        ImagePageTypeId: ImagePageTypeId || 0,
        ClassificationCategory: category.trim(),
        Group: group.trim(),
        Delete: false,
        Roles: [],
        tempId: `${category}-${group}`,
      },
    ])
    closeModal()
  }

  return (
    <React.Fragment>
      <div>
        <div className="classifications-property-label">
          {`Classifications: 'Category - Group'`}
          <br />
        </div>
        <div className="settings-list-wrapper">
          <CommonList
            allowDelete
            list={filteredList}
            itemTitle="Classifications"
            deleteItem={deleteClassification}
          />
          <ContextButton
            variant="secondary"
            onClick={() => {
              setClassificationModalOpen(true)
            }}
          >
            <CrossHeavy />
          </ContextButton>
        </div>
      </div>
      <Portal isOpened={classificationModalOpen}>
        <Modal
          title={`Classification Definitions`}
          cancelButton
          autoHeight
          modalSize={'small'}
          closeModal={closeModal}
        >
          <div className="change-password-modal">
            <div className="text-select-row">
              <TextInput
                label={
                  <span>
                    <span style={{ color: `hsl(345,100%,42%)` }}>*</span>Category
                  </span>
                }
                value={category}
                onChange={(e) => {
                  setCategory(e.target.value)
                }}
              />
              <button
                className={`btn btn-primary btn-raised picker-button `}
                aria-label={`Open Category Options`}
                onClick={() => {
                  setShowCategoryOptions((open) => !open)
                }}
              >
                {showCategoryOptions ? <CaretUp /> : <CaretDown />}
              </button>
            </div>
            {showCategoryOptions && (
              <div className="settings-list-wrapper">
                <CommonList
                  list={(optionsMap['classificationCategories'] || []).map((category) => {
                    return {
                      Id: category.value,
                      Name: category.label,
                    }
                  })}
                  itemTitle="Categories"
                  selectItem={(row) => {
                    setCategory(row.Id)
                    setShowCategoryOptions(false)
                  }}
                />
              </div>
            )}
            <div className="text-select-row">
              <TextInput
                label={
                  <span>
                    <span style={{ color: `hsl(345,100%,42%)` }}>*</span>Group
                  </span>
                }
                value={group}
                onChange={(e) => {
                  setGroup(e.target.value)
                }}
              />
              <button
                className={`btn btn-primary btn-raised picker-button `}
                aria-label={`Open Group Options`}
                onClick={() => {
                  setShowGroupOptions((open) => !open)
                }}
              >
                {showGroupOptions ? <CaretUp /> : <CaretDown />}
              </button>
            </div>
            {showGroupOptions && (
              <div className="settings-list-wrapper">
                <CommonList
                  list={(optionsMap['classificationGroups'] || []).map((group) => {
                    return {
                      Id: group.value,
                      Name: group.label,
                    }
                  })}
                  itemTitle="Groups"
                  selectItem={(row) => {
                    setGroup(row.Id)
                    setShowGroupOptions(false)
                  }}
                />
              </div>
            )}
            {showError && <div>Missing Required Fields</div>}

            <div className="context-buttons">
              <button
                className={`btn btn-primary btn-raised picker-button `}
                aria-label={`Add Classification`}
                onClick={addClassification}
              >
                Add Classification
              </button>
            </div>
          </div>
        </Modal>
      </Portal>
    </React.Fragment>
  )
}

export default ImageClassificationDefinitions

// const dummy = [
//   {
//     ImageClassificationDefinitionId: 1024,
//     CreatedDate: '2022-10-26T16:18:51.037',
//     LastModifiedDate: '2022-10-26T16:18:51.037',
//     ImageDataTypeCategory: 'Notary',
//     Group: 'Other',
//     Icon: 'docAdd.png',
//     NameOverride: 'Additional Page',
//     ImagePageTypeId: 33,
//     ImagePageType: null,
//     ImagePageDescription: 'Additional Page',
//     Roles: [],
//     Delete: null,
//     IMAGE_CLASSIFICATION_DEFINITION: {
//       IMAGE_CLASSIFICATION_DEFINITION_ID: 1024,
//       CATEGORY: 'Notary',
//       GROUP: 'Other',
//       IMAGE_DATA_TYPE_ID: 33,
//       ICON: 'docAdd.png',
//       NAME_OVERRIDE: 'Additional Page',
//       CREATED_DATE: '2022-10-26T16:18:51.037',
//       LAST_MODIFIED_DATE: '2022-10-26T16:18:51.037',
//       IMAGE_DATA_DESCRIPTION_RO: 'Additional Page',
//       Roles: [],
//     },
//   },
// ]
